import React from "react";
import ReactDOM from "react-dom/client";
import Resume from "./Resume";
import "./globals.css";

ReactDOM.createRoot(document.getElementById("root")).render(
    <React.StrictMode>
        <Resume />
    </React.StrictMode>
);
